<template>
    <div id="pay_form">
        <div v-show="!prop_user_hashid">
            <div  class="d-flex justify-content-between align-items-baseline bg-white shadow-sm mb-3 p-1">
                <active-token
                    :title="$t('label.bank_status')"
                />
                <div>
                    <button type="button"
                            class="btn btn-success m-2"
                            :disabled="pay_settlement_is_loading"
                            @click="paySettlements()"
                            v-if="$can('manage-payment-settlement-requests', 'wallet')"
                    >
                        {{ $t('label.pay_settlements') }}
                        <i v-if="pay_settlement_is_loading" class="fas flaticon-refresh fa-spin" ></i>
                    </button>
                </div>
            </div>
        </div>

        <kt-panel>
            <div class="accordion accordion-toggle-arrow" id="userFilter">
                <div class="card" style="overflow:inherit">
                    <div class="card-header bg-transparent" id="headingOne">
                        <div class="card-title collapsed" data-toggle="collapse"
                             data-target="#filterForm"
                             aria-controls="filterForm">
                            {{ $t('label.search') }}
                        </div>
                    </div>
                    <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)" id="settlement_export_form">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="statusSelectGroup">
                                                <kt-form-label for="status">
                                                    {{ $t('label.status') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="status" class="form-control"
                                                                name="status" v-model="query.status"
                                                >
                                                    <option :value="null" v-text="$t('label.all_statuses')"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.PENDING"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.PENDING)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.CREATED"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.CREATED)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.UNKNOWN_YET"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.UNKNOWN_YET)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.SUCCESS"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.SUCCESS)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.FAILED"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.FAILED)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.FAILED_NOT_SENT"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.FAILED_NOT_SENT)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.CANCELED"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.CANCELED)"
                                                    ></option>
                                                    <option :value="walletTransactionStatus.SETTLEMENT_PENDING"
                                                            v-text="walletTransactionStatusStr.get(walletTransactionStatus.SETTLEMENT_PENDING)"
                                                    ></option>
                                                    <option value="-2"
                                                            v-text="$t('label.reversal')"
                                                    ></option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="from_date">
                                                    {{ $t('label.from_date') }}
                                                </kt-form-label>
                                                <button id="reset_from_date"
                                                        @click="clearFromDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                        format="YYYY-MM-DD HH:mm:ss"
                                                        display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                        input-class="form-control"
                                                        id="from_date"
                                                        name= "from_date"
                                                        v-model="query.from_date"
                                                        type="datetime" />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="to_date">
                                                    {{ $t('label.to_date') }}
                                                </kt-form-label>
                                                <button id="reset_to_date"
                                                        @click="clearToDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                        format="YYYY-MM-DD HH:mm:ss"
                                                        display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                        input-class="form-control"
                                                        id="to_date"
                                                        name= "to_date"
                                                        v-model="query.to_date"
                                                        type="datetime"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2" v-show="!prop_user_hashid">
                                            <label for="user_id"
                                                   v-text="$t('label.user_id')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="user_id"
                                                   name= "user_id"
                                                   class="form-control"
                                                   v-model="query.user_id"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="collection_id"
                                                   v-text="$t('label.collection_id')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="collection_id"
                                                   name= "collection_id"
                                                   class="form-control"
                                                   v-model="query.collection_id"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="wallet_hashid"
                                                   v-text="$t('label.wallet_hashid')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="wallet_hashid"
                                                   name= "wallet_hashid"
                                                   class="form-control"
                                                   v-model="query.wallet_hashid"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="min_amount"
                                                   v-text="$t('label.min_amount')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="min_amount"
                                                   name= "min_amount"
                                                   class="form-control"
                                                   v-model="query.min_amount"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="max_amount"
                                                   v-text="$t('label.max_amount')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="max_amount"
                                                   name= "max_amount"
                                                   class="form-control"
                                                   v-model="query.max_amount"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="transaction_hashid"
                                                   v-text="$t('label.transaction_hashid')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="transaction_hashid"
                                                   name= "transaction_hashid"
                                                   class="form-control"
                                                   v-model="query.transaction_hashid"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="iban"
                                                   v-text="$t('label.iban')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="iban"
                                                   name= "iban"
                                                   class="form-control"
                                                   v-model="query.iban"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="destination_last_name"
                                                   v-text="$t('label.destination_last_name')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="destination_last_name"
                                                   name= "destination_last_name"
                                                   class="form-control"
                                                   v-model="query.destination_last_name"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2" v-show="!prop_user_hashid">
                                            <label for="fullname"
                                                   v-text="$t('label.fullname')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="fullname"
                                                   name= "fullname"
                                                   class="form-control"
                                                   v-model="query.fullname"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="bank_id"
                                                   v-text="$t('label.bank')"
                                            >
                                            </label>
                                            <select id="bank_id"
                                                   class="form-control"
                                                   v-model="query.bank_id"
                                            >
                                                <option :value="null" selected>{{ $t('label.all_banks') }}</option>
                                                <option v-text="bankIdStr.get(bankId.ayande)" :value="bankId.ayande"></option>
                                                <option v-text="bankIdStr.get(bankId.saderat)" :value="bankId.saderat"></option>
                                                <option v-text="bankIdStr.get(bankId.keshavarzi)" :value="bankId.keshavarzi"></option>
                                                <option v-text="bankIdStr.get(bankId.saman)" :value="bankId.saman"></option>
                                                <option v-text="bankIdStr.get(bankId.parsian)" :value="bankId.parsian"></option>
                                                <option v-text="bankIdStr.get(bankId.pasargad)" :value="bankId.pasargad"></option>
                                                <option v-text="bankIdStr.get(bankId.melli)" :value="bankId.melli"></option>
                                                <option v-text="bankIdStr.get(bankId.tejarat)" :value="bankId.tejarat"></option>
                                                <option v-text="bankIdStr.get(bankId.mellat)" :value="bankId.mellat"></option>
                                            </select>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="bank_ref_code"
                                                   v-text="$t('label.bank_ref_code')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="bank_ref_code"
                                                   name= "bank_ref_code"
                                                   class="form-control"
                                                   v-model="query.bank_ref_code"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="reversed_type"
                                                   v-text="$t('label.reversed_type')"
                                            >
                                            </label>
                                            <select id="reversed_type"
                                                    class="form-control"
                                                    v-model="query.reversed_type"
                                            >
                                                <option :value="null"></option>
                                                <option v-text="$t('label.reversed_automatically')" value="0"></option>
                                                <option v-text="$t('label.reversed_by_admin')" value="1"></option>
                                            </select>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="detected_type"
                                                   v-text="$t('label.detected_type')"
                                            >
                                            </label>
                                            <select id="detected_type"
                                                    class="form-control"
                                                    v-model="query.detected_type"
                                            >
                                                <option :value="null"></option>
                                                <option v-text="$t('label.reversed_automatically')" value="0"></option>
                                                <option v-text="$t('label.reversed_by_admin')" value="1"></option>
                                            </select>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" class="mt-4">
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                            <button v-if="$can('export-excel', 'wallet')" id="settlement_excel_export" type="button" class="btn btn-success btn-wide mx-4" @click="exportToExcel">{{ $t('label.excel_export') }}</button>
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </kt-panel>
        <div class="row my-2" v-if="$can('read-statistics','wallet')">
            <div class="col-6">
                <transactionStat
                        :transactionStatistics="success_tr_amount_sum"
                        :title="$t('label.total_succeed_settlement_amount')"
                        :needCurrency="true"
                />
            </div>
            <div class="col-6">
                <transactionStat
                        :transactionStatistics="success_tr_count"
                        :title="$t('label.succeeded_settlement_count')"
                        :needCurrency="false"
                />
            </div>
        </div>
        <kt-datatable ref="datatable" v-bind="datatableProps">
        </kt-datatable>
    </div>
</template>

<script>
    import {ApiUrl, walletService, authService} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import columns from "../datatable/transaction-columns.js";
    import adminSettlementActions from "../datatable/adminSettlementActions";
    import $ from 'jquery'
    import {i18n} from "@/plugins/i18n";
    import {walletTransactionStatus, walletTransactionStatusStr} from "@/constants/walletTransactionStatus";
    import transactionStat from '@/views/transaction/components/transaction-statistic'
    import {bankId, bankIdStr} from "@/constants/bankId";
    import ActiveToken from "@/views/transaction/components/active-token.vue";
    import { KTApp } from '@/plugins/core/app'
    import axios from "axios";
    import {walletTransactionType} from "@/constants/walletTransactionType";

    export default {
        components: {
            ActiveToken,
            transactionStat,
        },
        data() {
            return {
                walletTransactionStatus,
                walletTransactionStatusStr,
                has_settlement_token: false,
                bankId,
                bankIdStr,
                query: {
                    from_date: null,
                    to_date: null,
                    bank_id: null,
                    user_id: this.prop_user_hashid,
                    bank_ref_code: null,
                    detected_type: null,
                    reversed_type: null
                },
                success_tr_count: 0,
                success_tr_amount_sum: 0,
                pay_settlement_is_loading: false,
            };
        },
        props: {
            prop_user_hashid : {
                required : false
            },
            fetch_starshop: {
                default: false,
                type: Boolean
            },
            api_base_path: {
                default: ApiUrl.path(''),
                type: String
            }
        },
        methods: {
            loadStats() {
                if (!this.$can('read-statistics', 'wallet')) {
                    return;
                }

              walletService.adminGetCoreSettlementListStats('A', this.query).then(res => {
                    const { success_tr_count, success_tr_amount_sum } = res.data.data;
                    
                    this.success_tr_count = success_tr_count;
                    this.success_tr_amount_sum = success_tr_amount_sum;
                });
            },
            filterAction(e, query) {
                this.query = query;

                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }

                this.loadStats();
            },
            clearFromDate() {
                if (this.query.from_date) {
                    this.query.from_date = null;
                }
            },
            clearToDate() {
                if (this.query.to_date) {
                    this.query.to_date = null;
                }
            },
            paySettlements() {
                let records = this.$refs.datatable.KTDatatable.getSelectedRecords();
                let ids = [];
                let form = $('#pay_form');

                for (let record of records) {
                    ids.push($(record).find('[data-field="id"]')[0].innerText);
                }

                if (ids.length < 1) {
                    return;
                }
                this.pay_settlement_is_loading = true;
                let phone = this.$store.state.user.current_user.phone;

                let verify = {
                    phone,
                };

                authService.sendVerifyWallet(verify).then(res => {
                    let code = prompt(i18n.t('message.are_you_sure_to_pay_this_settlement_list'), '');

                    if (code === null || code === undefined || code === '') {
                        return;
                    }

                    let params = {
                        wallet_prefix: 'A',
                        ids,
                        code,
                        phone,
                    };

                  walletService.payCoreSettlementListAyande(params)
                        .then(res => {
                            window.location.reload();
                        })
                    .catch(({ response }) => {
                        this.showMsg(form, 'danger', response.data.message);
                    });
                }).catch(({ response }) => {
                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                    setTimeout(() => {
                        this.pay_settlement_is_loading = false;
                    }, 2000)
                });
            },
            exportToExcel(e){

                let form = $('#settlement_export_form')
                let btn = $('#settlement_export_btn')

                if(!form.valid()) {
                    return
                }

                this.query.transaction_type = walletTransactionType.SETTLEMENT;

                if (this.prop_user_hashid !== undefined){
                    this.query.user_id = this.prop_user_hashid;
                }



                KTApp.progress(btn)
                axios({
                    url: ApiUrl.path('wallet/common/admin/transactions-excel-report'),
                    method: 'GET',
                    params: {query: this.query},
                    responseType: 'blob',
                })
                    .then((response) => {
                        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        let fileLink = document.createElement("a");

                        fileLink.href = fileURL;
                        fileLink.setAttribute("download", "Settlements.xlsx");
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        KTApp.unprogress(btn)

                    })
                    .catch(({response}) => {
                        KTApp.unprogress(btn)
                        this.toastr.error(response.data.message)
                    })
                    .finally(()=>{
                        delete this.query.transaction_type;
                    })
            },

        },
        mounted() {
            this.loadStats();
        },
        computed: {
            datatableProps() {
                return {
                    id: "wallets_transactions_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('wallet/ayande/admin/settlement-list/A'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: res => {
                                    let result = [];

                                    for (let item of res.data.data) {
                                        result.push({...item, check: false});
                                    }

                                    return result;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: adminSettlementActions,
                    selector: {
                        class: 'kt-checkbox--solid'
                    },
                }
            },
        },
    }
</script>
